import { render, staticRenderFns } from "./CalendarIconSvg.vue?vue&type=template&id=70832569"
import script from "./CalendarIconSvg.vue?vue&type=script&lang=ts"
export * from "./CalendarIconSvg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports